import { Button, Card, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText, TextField, Typography, Box } from "@mui/material";
import { BookingService } from "../../Service";
import Swal from "sweetalert2";
import { useState } from "react";
import ReschedulingForm from "./ReschedulingForm";
import CancellForm from "./CancellForm";

const CancelAndReschedule = ({bookingDetailsdata,fetchBookingDetalById}) => {
    const [openCancellationDialog, setOpenCancellationDialog] = useState(false);
    const [cancellationMessage, setCancellationMessage] = useState('');
    // const [isCancelling, setIsCancelling] = useState(false);
    const onCancel = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to cancel this booking!',
            icon: 'warning',
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonText: 'Yes, Cancel it!',
            cancelButtonText: 'No, Keep it'
        });
        if(result.isConfirmed){
            // open a dialog to take the reason for cancellation
            setOpenCancellationDialog(true);
        }
    }
    const handleCancelBooking = async (data) => {
        Swal.fire({
            title: 'Cancelling Booking',
            text: 'Please wait while we cancel the booking!',
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const requiredDataForCancellation = {
            bookingNumber:bookingDetailsdata?.bookingNumber, 
            ...data
        }
        const cancellationResponse = await BookingService.cancelBooking(requiredDataForCancellation);
        if(cancellationResponse.success == '1'){
            fetchBookingDetalById();
        }
        Swal.fire({
            title: cancellationResponse.message,
            icon: cancellationResponse.success == '1' ? 'success' : 'error'
        });
        setOpenCancellationDialog(false);
    }

    const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);

    const onReschedule = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to reschedule this booking!',
            icon: 'warning',
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonText: 'Yes, Reschedule it!',
            cancelButtonText: 'No, Keep it'
        });
        if(result.isConfirmed){
            // open a dialog to take the reason for cancellation
            setOpenRescheduleDialog(true);
        }
    }
    const handleRescheduleBooking = async (data) => {
        Swal.fire({
            title: 'Rescheduling Booking',
            text: 'Please wait while we reschedule the booking!',
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const requiredDataForReschedule = {
            bookingNumber:bookingDetailsdata?.bookingNumber,
            ...data
        }
        
        console.log("Reschedule Data",requiredDataForReschedule);
        const rescheduleResponse = await BookingService.rescheduleBooking(requiredDataForReschedule);
        if(rescheduleResponse.success == '1'){
            fetchBookingDetalById();
        }
        Swal.fire({
            title: rescheduleResponse.message,
            icon: rescheduleResponse.success == '1' ? 'success' : 'error'
        });
        setOpenRescheduleDialog(false);
    }
    return (
        <>
            <Card sx={{display:'flex',justifyContent:'center',gap:2,mb:'2%',p:1}}>
                <Button variant='outlined' size='small' color='error' sx={{textTransform:'capitalize'}} onClick={()=>onCancel()}>
                    Cancel Booking
                </Button>
                <Button variant='contained' size='small' sx={{textTransform:'capitalize',color:'#fff',bgcolor:'#3a2bde'}} onClick={()=>onReschedule()}>
                    Reschedule Booking
                </Button>
            </Card>
            {/* cancellation dialog */}
            <Dialog 
                open={openCancellationDialog} 
                // onClose={() => setOpenCancellationDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <Box sx={{p:'1% 2%',borderBottom:'1px solid #E0E0E0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <Typography sx={{fontSize:'0.85rem',fontWeight:'600',}}>Booking Cancellation Detail's</Typography>
                    <Button size="small" variant="outlined" color='error' onClick={()=>setOpenCancellationDialog(false)}>
                        Close
                    </Button>
                </Box>
                <Box sx={{p:'1% 2%'}}>
                    <CancellForm onClose={handleCancelBooking} onCancel={()=>setOpenCancellationDialog(false)} />
                </Box>
            </Dialog>
            {/* ReScheduling dialog */}
            <Dialog
                open={openRescheduleDialog}
                // onClose={() => setOpenRescheduleDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Reschedule Booking
                </DialogTitle>
                <DialogContent>
                    <ReschedulingForm onClose={handleRescheduleBooking} onCancel={()=>setOpenRescheduleDialog(false)} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default CancelAndReschedule;